/*
 * Copyright (c) Nexign, JSC, 2020.
 */
/**
 * Constants for Settings component
 *
 * @author Anton Panasenko
 * @version 1.3.0
 * @since 1.3.0
 */


export const SETTINGS_LOADER_START = '@@b2b_portal_ui/settings/SETTINGS_LOADER_START';
export const SETTINGS_LOADER_STOP = '@@b2b_portal_ui/settings/SETTINGS_LOADER_STOP';
